// extracted by mini-css-extract-plugin
export default {"subheading":"SensorDetails_subheading__xNska","tabs":"SensorDetails_tabs__X1j21"};